export const mapId = process.env.REACT_APP_MAP_ID;

export const venueId = process.env.REACT_APP_VENUE_ID